import { render } from "./SurveysPage.vue?vue&type=template&id=52bdb570"
import script from "./SurveysPage.vue?vue&type=script&lang=js"
export * from "./SurveysPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__